import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const dataHooks = createDataHooks<{
  skip: {}
}>('wix-studio-mobile-header')
